import React from "react";
import { Card, CardHeader, CardBody, Container, Row, Col } from "reactstrap";
import AuthHeader from "components/Headers/AuthHeader.js";
import { FOUNDER, FACEBOOK_URL } from "variables/publicContent";

export default function About() {
  React.useEffect(() => {
    document.title = "About - Bite Logr";
  }, []);
  const hasFounder = FOUNDER.name && FOUNDER.story;

  return (
    <>
      <AuthHeader title="About" lead="" deviceType={false} />
      <Container className="mt--8 pb-5">
        <Row className="justify-content-center">
          <Col lg="8">
            <Card className="border-0 mb-4">
              <CardHeader className="bg-transparent">
                <h2 className="mb-0">About Bite Logr</h2>
              </CardHeader>
              <CardBody>
                <p>
                  Bite Logr is a fishing app built by anglers. Pros log their
                  catches and get paid when anglers subscribe to see their
                  patterns. Anglers follow pros on their local waters and see
                  what is working and when.
                </p>
                <p className="mb-0">
                  We built it because it takes years on the water to become a
                  consistent fisherman, and most pros never get paid for what
                  they know.
                </p>
              </CardBody>
            </Card>

            {hasFounder && (
              <Card className="border-0 mb-4">
                <CardHeader className="bg-transparent">
                  <h2 className="h3 mb-0">Why I built Bite Logr</h2>
                </CardHeader>
                <CardBody className="d-flex flex-wrap align-items-start">
                  {FOUNDER.photo && (
                    <img
                      src={FOUNDER.photo}
                      alt={FOUNDER.name}
                      className="rounded-circle mr-4 mb-3"
                      style={{ width: 120, height: 120, objectFit: "cover" }}
                    />
                  )}
                  <div style={{ flex: "1 1 260px" }}>
                    <p className="font-weight-bold mb-1">
                      {FOUNDER.name}
                      {FOUNDER.location && `, ${FOUNDER.location}`}
                    </p>
                    <p>{FOUNDER.story}</p>
                    <p className="mb-0">
                      {FOUNDER.linkedin && (
                        <a href={FOUNDER.linkedin} className="mr-3">
                          LinkedIn
                        </a>
                      )}
                      {FOUNDER.x && (
                        <a href={FOUNDER.x} className="mr-3">
                          X
                        </a>
                      )}
                    </p>
                  </div>
                </CardBody>
              </Card>
            )}

            <Card className="border-0 mb-4">
              <CardHeader className="bg-transparent">
                <h2 className="h3 mb-0">Contact</h2>
              </CardHeader>
              <CardBody>
                {/* TODO(owner): add a support email so contact isn't Facebook-only. */}
                <a href={FACEBOOK_URL} target="_blank" rel="noreferrer">
                  Message us on Facebook
                </a>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
